/**
 * Loader bajo demanda para Cloudflare Turnstile
 * Garantiza que el script solo se descargue cuando un componente realmente lo necesita
 * y nunca bloquea ni cuelga la aplicación.
 */

let turnstilePromise = null;

export function loadTurnstile() {
    if (typeof window === 'undefined') {
        return Promise.resolve(null);
    }

    if (window.turnstile && typeof window.turnstile.render === 'function') {
        return Promise.resolve(window.turnstile);
    }

    if (turnstilePromise) {
        return turnstilePromise;
    }

    turnstilePromise = new Promise((resolve) => {
        const url = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
        
        // Timeout de seguridad global de 4s
        const timeout = setTimeout(() => {
            if (window.turnstile && typeof window.turnstile.render === 'function') {
                resolve(window.turnstile);
            } else {
                turnstilePromise = null;
                resolve(null);
            }
        }, 4000);

        const checkReady = (retries = 0) => {
            if (window.turnstile && typeof window.turnstile.render === 'function') {
                clearTimeout(timeout);
                resolve(window.turnstile);
            } else if (retries < 80) {
                setTimeout(() => checkReady(retries + 1), 50);
            } else {
                clearTimeout(timeout);
                turnstilePromise = null;
                resolve(null);
            }
        };

        const existingScript = document.querySelector(`script[src*="challenges.cloudflare.com/turnstile"], #cf-turnstile-script`);
        if (existingScript) {
            checkReady();
            return;
        }

        const script = document.createElement('script');
        script.id = 'cf-turnstile-script';
        script.src = url;
        script.async = true;
        script.defer = true;
        script.onload = () => checkReady();
        script.onerror = () => {
            clearTimeout(timeout);
            turnstilePromise = null;
            resolve(null);
        };
        document.head.appendChild(script);
    });

    return turnstilePromise;
}
